import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { history } from "src/services/history";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { PATHNAMES } from "src/constants/routes";
import { IClone } from "src/@types/clones";

export const CURRENT_CLONE_SLICE_NAME = "currentClone";

interface Params {
  id: string;
}

export const getCurrentCloneAsync = createAsyncThunk(
  `${CURRENT_CLONE_SLICE_NAME}/fetchCurrentClone`,
  async ({ id }: Params, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IClone>(`/clones/${id}/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      history.push(PATHNAMES.HOME, { replace: true });

      NotificationService.error(errorText || errorResponsesTrns.currentClone);

      return rejectWithValue(errorText);
    }
  }
);
